export default __webpack_public_path__ + "navigation-examples-custom-waypoint-thumbnail-960-71265c5c4fed5192b824b35d59339fd2.webp";